import React from 'react';
import styles from '../RateView.module.css';
import FilterLabel from './FilterLabel';

class FilterNumberDiapason extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			valueFrom: '',
			valueTo: ''
		}
	}
	componentDidMount() {
		let rateView = this.props.rateView;
		rateView.registerFilter( this );
	}
	componentWillUnmount() {
		let rateView = this.props.rateView;
		rateView.unregisterFilter( this );
	}

	clearFilter() {
		this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
		this.setState({valueFrom: '', valueTo: ''});
	}	
	handleEdit = e => {
		this.props.rateView.clearData();
		let valueFrom = this.state.valueFrom;
		let valueTo = this.state.valueTo;
		
		const { name, value } = e.target;
		if( name == 'from' ) {
			this.setState({valueFrom: value});
			valueFrom = value;
		} else {
			this.setState({valueTo: value});
			valueTo = value;
		}

		if( valueFrom == '' && valueTo == '' ) {
			this.props.rateView.clearQueryFilter( this.props.filter.predicateId )
			return;
		}
		
		this.setValues(valueFrom, valueTo);
	}
	setValues = (valueFrom, valueTo) => {
		let q = this.props.rateView.query;
		let indexFilter = -1;
		for(let i=0; i < q.listPredicate.length; i++) {
			if( q.listPredicate[i].predicateId == this.props.filter.predicateId ) {
				indexFilter = i;
				break;
			}
		}
		if( indexFilter < 0 ) {
			q.listPredicate.push( {
				predicateId: this.props.filter.predicateId,
				conditionId: this.props.filter.conditionId,
				valueFrom: valueFrom,
				valueTo: valueTo
			} );
		} else {
			q.listPredicate[indexFilter].valueFrom = valueFrom;
			q.listPredicate[indexFilter].valueTo = valueTo;
		}
	}	

	fetchProfile = () => {
		if( this.state.valueFrom.trim() || this.state.valueTo.trim())
			return {
				filterId: this.props.filter.predicateId, 
				valueFrom: this.state.valueFrom, 
				valueTo: this.state.valueTo
			};
		else
			return null;
	}
	applyProfile = (profile) => {
		this.setValues( profile.valueFrom, profile.valueTo );
		this.setState({valueFrom: profile.valueFrom, valueTo: profile.valueTo});
	}
	
	render() {
		let filter = this.props.filter;
		let step = this.props.filter.decimal ? 0.01 : 1;
		return (
			<div className={styles.divFilter}>
				<FilterLabel title={filter.title} tooltip={filter.tooltip} />
				<div className={styles.divFilterInput}>
					<input name="from" className={styles.inputFilterPartValue} type='number' step={step} value={this.state.valueFrom} onChange={this.handleEdit}/>
					&nbsp;-&nbsp;
					<input name="to" className={styles.inputFilterPartValue} type='number' step={step} value={this.state.valueTo} onChange={this.handleEdit}/>
				</div>
			</div>
		);
	}	
}

export default FilterNumberDiapason;